import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"
import { turboRequestInFlight } from "../utils/turbo-refresh.util"

// Fallback for the export status page while the export is in progress.
//
// The page renders `pending`, then the cable subscription (turbo_stream_from)
// connects asynchronously; a sub-second export's final refresh broadcast can
// land before it does, and the page would spin forever. So while the running
// or queued status is rendered, the page re-visits itself in place every
// interval. It stops by itself: a terminal status does not render this
// controller, and the visit's new body disconnects the old instance.
//
// A tick never starts a visit while Turbo has one in flight: Turbo.visit stops
// the current visit and form submission first, so it would swallow the
// member's own click (and a server slower than the interval would never show
// the finished state). The interval is the retry, so a busy tick is skipped
// rather than re-scheduled (see turbo-refresh.util). Like Turbo's own
// broadcast refresh, these visits leave no snapshot of the spinner page in the
// Back cache.
export default class extends Controller {
  static values = { interval: { type: Number, default: 5000 } }

  connect() {
    this.timer = setInterval(() => {
      if (turboRequestInFlight()) return

      Turbo.visit(window.location.href, { action: "replace", shouldCacheSnapshot: false })
    }, this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
    this.timer = null
  }
}
